import React, { Fragment, useRef, useState, useEffect } from "react";
import { Quiz } from "App";
import Carousel from 'ReusableComponents/Carousel/Carousel';
import QuizDB, { fetchQuizLocal, getFirstQuizQuestionName, } from 'quizdb'
import SubmitEmail from './SubmitEmail'
import { sortQuestionEntries, getQuizName, setQuizName,
         setQuestionName as lib_setQuestionName, getQuestionName, } from 'lib';

function startAt(quiz, questionName) {
  const numQuestions = quiz.findIndex((entry) => entry[0] === questionName);
  quiz.splice(0, numQuestions);
}

export default function RenderQuizData(props: any) {
  const {
    showEmail,
    ...rest
  } = props;
  const [quiz, setQuiz] = useState(fetchQuizLocal(getQuizName()));
  const [questionName, setQuestionName] = useState(getQuestionName());
  const ref = useRef();
  const [showQuestions, setShowQuestions] = useState(false);

  const showQuizQuestions = () => {
    setShowQuestions(true)
  }

  const cleanUp = () => {
    document.querySelectorAll('audio').forEach(audio => audio.pause())
  }

  const nextQuestion = () => {
    cleanUp()
    ref.current.next();
  }

  const questionsSorted = sortQuestionEntries(quiz);
  if (!showEmail) {
    startAt(questionsSorted, questionName);
  }

  const QuestionComponents = questionsSorted.map((entry, index) => {
    const enableCheckAnswer = entry[1].every(tool => tool.element !== "FinishPage");
    const enableQuizProgress = enableCheckAnswer;
    return (
      <div key={index}>
        <Quiz
          data={entry[1]}
          questionsKey={entry[0]}
          onSubmit={nextQuestion}
          questionsIndex={index}
          {...{...rest, enableCheckAnswer, enableQuizProgress}}
        />
      </div>
    )
  })

  useEffect(() => {
    let isMounted = true;

    if (showQuestions) {
      if (isMounted) ref.current.next();
    }

    return () => { isMounted = false }
  }, [showQuestions])

  const onNameChange = (event) => {
    const quizName = event.detail.quizName
    const questionName = event.detail.questionName
    setQuizName(quizName);
    lib_setQuestionName(questionName);
    setQuiz(fetchQuizLocal(quizName));
    setQuestionName(questionName);
  }

  useEffect(() => {
    let isMounted = true;
    document.addEventListener('NameChange', onNameChange);
    return () => {
      isMounted = false;
      document.removeEventListener('NameChange', onNameChange);
    }
  }, [])

  return (
    <Fragment>
      <Carousel ref={ref}>
        {showEmail && <SubmitEmail onSubmit={showQuizQuestions} />}
        {QuestionComponents}
      </Carousel>
    </Fragment>
  );
} 